import React, { useState, useEffect } from "react";
import { API_BASE } from "../../apiBase";
import { withSeed } from "../../utils";
import "../Products/Products.css";
import { useAuth0 } from "@auth0/auth0-react";
import A2WCardSwipper from "./Components/A2WCardSwipper";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import A2WFilterBar from "./Components/A2WFilterBar";
import A2WProductsTable from "./Components/A2WProductsTable";

export default function A2WProductsPage(props) {
  const urlParams = new URLSearchParams(window.location.search);
  const {
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    loginWithRedirect,
  } = useAuth0();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [isProductsLoading, setIsProductsLoading] = useState(true);
  const [noPermissions, setNoPermissions] = useState(false);
  const [filters, setFilters] = useState({search: urlParams.has("asin") ? urlParams.get('asin') : ""});

  useEffect(() => {
    const loadProducts = async () => {
      setIsProductsLoading(true);
      const accessToken = await getAccessTokenSilently();
      fetch(
        API_BASE + "/load_a2w_products_by_page/" +
          page +
          "/" +
          JSON.stringify(withSeed(filters)) +
          "/",
        { mode: "cors", headers: { Authorization: `Bearer ${accessToken}` } }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data === "No permissions") {
            setNoPermissions(true);
          } else {
            setNoPermissions(false);
            if (data.length > 0 && !props.isMobile && !(new Date(data[0].title.split("Last Update: ")[1]).toDateString().includes("Invalid"))) {
              let filteredData = data.filter(product => (((new Date() - new Date(product.title.split("Last Update: ")[1])) / 1000 / 60 / 60) <= 72))
              if (filteredData.length > 0) {
                setData(filteredData);
                setIsProductsLoading(false);
              } else {
                setPage(page => page + 1)
              }
            } else {
              setData(data)
              setIsProductsLoading(false);
            }
          }
        });
    };

    if (!isLoading && isAuthenticated) {
      loadProducts();
    }
  }, [page, filters, getAccessTokenSilently, isLoading, isAuthenticated, props.isMobile]);


  if (noPermissions) {
    navigate("/pricing");
  }
  if (!isLoading && !isAuthenticated) {
    return (
      <div style={{ textAlign: "center", marginBottom: "80vh" }}>
        <Helmet>
          <title>Nepeto - Amazon to Walmart</title>
          <link rel="canonical" href="https://www.nepeto.com/amazon-to-walmart" />
          <meta
            name="description"
            content="Explore Amazon to Walmart (Amazon 2 Walmart Flips) products. Discover profitable opportunities."
          />
          <meta
            name="keywords"
            content="amazon fba, product sourcing, a2w, amazon to walmart, amazon flips, amazon fba products, fba products, fba sourcing"
          />
        </Helmet>
        <br />
        <br />
        <p
          style={{
            width: "80vw",
            margin: "auto",
            fontSize: "200%",
            boxShadow: "0px 0px 5px 1px #8c3e7c",
            padding: "2%",
          }}
        >
          To use Nepeto, sign up and subscribe to one of our plans. You can
          start with a free sign-up and enjoy a free trial!
          <br />
          <br />
          <button
            className="button is-rounded is-size-6-mobile is-size-6-tablet"
            style={{
              backgroundColor: "#32CD32",
              margin: "auto",
              color: "#ffffff",
            }}
            onClick={() =>
              loginWithRedirect({
                authorizationParams: {
                  screen_hint: "signup",
                },
                appState: { returnTo: "/pricing?s=1" },
              })
            }
          >
            Sign up for Free!
          </button>
        </p>
      </div>
    );
  }

  return (
    <div className="products">
        <Helmet>
          <title>Nepeto - Amazon to Walmart</title>
          <link rel="canonical" href="https://www.nepeto.com/amazon-to-walmart" />
          <meta
            name="description"
            content="Explore Amazon to Walmart (Amazon to Walmart Flips) products. Discover profitable opportunities."
          />
          <meta
            name="keywords"
            content="amazon fba, product sourcing, a2w, amazon to walmart, amazon flips, amazon fba products, fba products, fba sourcing"
          />
        </Helmet>
      <h1
        style={{
          fontSize: props.isMobile ? "3vh" : "2vw",
          fontWeight: "380",
          textAlign: "center",
          color: "#8c3e7c",
          marginBottom: props.isMobile && "1vh",
        }}
      >
        Amazon to Walmart
        <br/>
        <p style={{fontSize: "50%", marginTop:"-0.8%", marginBottom: "0.8%"}}>Buy from Amazon and sell on Walmart</p>
      </h1>
      {isProductsLoading ? (
        <progress className="progress" style={{ marginBottom: "77vh" }} />
      ) : props.isMobile ? (
        <>
          <A2WFilterBar
            isMobile={props.isMobile}
            setFilters={setFilters}
            filters={filters}
          />
          <A2WCardSwipper data={data} setPage={setPage} hideCredits={props.hideCredits} />
        </>
      ) : (
        <>
          <A2WFilterBar
            isMobile={props.isMobile}
            setFilters={setFilters}
            filters={filters}
          />
          <A2WProductsTable
            data={data}
            setPage={setPage}
            page={page}
            isMobile={props.isMobile}
            hideCredits={props.hideCredits}
            setFilters={setFilters}
            filters={filters}
          />
        </>
      )}
    </div>
  );
}
